import { render, staticRenderFns } from "./LRoutingMachine.vue?vue&type=template&id=0c38621c"
import script from "./LRoutingMachine.vue?vue&type=script&lang=js"
export * from "./LRoutingMachine.vue?vue&type=script&lang=js"
import style0 from "./LRoutingMachine.vue?vue&type=style&index=0&id=0c38621c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports